var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-custom-scrollbar",
    {
      class: [
        "modal fade go-modal-detail",
        { show: _vm.isShowDetailArticle, "d-block": _vm.isShowDetailArticle },
      ],
      attrs: { tabindex: "-1", id: "go-detail-default" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body" }, [
            _vm.isLoading
              ? _c(
                  "div",
                  { staticClass: "go-detail-container" },
                  [
                    _c("div", { staticClass: "go-detail-toolbar" }, [
                      _c("div", { staticClass: "go-fixed-box" }, [
                        _c("div", { staticClass: "go-btn-group" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn go-btn-icon",
                              attrs: {
                                type: "button",
                                "data-dismiss": "modal",
                              },
                              on: { click: _vm.handleClosePopup },
                            },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      value: {
                                        placement: "topright",
                                        customClass: "go-tooltip",
                                      },
                                      expression:
                                        "{ placement: 'topright', customClass: 'go-tooltip' }",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  staticClass: "go-tooltip-area",
                                  attrs: { title: _vm.$t("report.close") },
                                },
                                [
                                  _c("i", {
                                    staticClass: "go-icon-24 go-icon-close",
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.checkToShowGroupButton
                          ? _c("div", { staticClass: "go-btn-group" }, [
                              _vm.checkToShowBookMarkButton
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn go-btn-icon",
                                      class: [
                                        {
                                          active:
                                            _vm.getSelectedResource
                                              .isBookmarked,
                                        },
                                      ],
                                      attrs: {
                                        type: "button",
                                        "data-toggle": "button",
                                        disabled: _vm.updatingBookmark,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.addToResource.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              value: {
                                                placement: "topright",
                                                customClass: "go-tooltip",
                                              },
                                              expression:
                                                "{ placement: 'topright', customClass: 'go-tooltip' }",
                                              modifiers: { hover: true },
                                            },
                                          ],
                                          staticClass:
                                            "go-tooltip-area go-toggle-off",
                                          attrs: {
                                            title: _vm.$t(
                                              "briefing.label.add-to-scrape"
                                            ),
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "go-icon-20 go-icon-bookmark",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              value: {
                                                placement: "topright",
                                                customClass: "go-tooltip",
                                              },
                                              expression:
                                                "{ placement: 'topright', customClass: 'go-tooltip' }",
                                              modifiers: { hover: true },
                                            },
                                          ],
                                          staticClass:
                                            "go-tooltip-area go-toggle-on",
                                          attrs: {
                                            title: _vm.$t(
                                              "briefing.label.remove-to-scrape"
                                            ),
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "go-icon-20 go-icon-bookmark-on",
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkToShow(
                                "hideButton",
                                _vm.getSelectedResource
                              )
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn go-btn-icon",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.callHideFunction.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              value: {
                                                placement: "topright",
                                                customClass: "go-tooltip",
                                              },
                                              expression:
                                                "{ placement: 'topright', customClass: 'go-tooltip' }",
                                              modifiers: { hover: true },
                                            },
                                          ],
                                          staticClass: "go-tooltip-area",
                                          attrs: {
                                            title: _vm.$t(
                                              "common.label.hidden"
                                            ),
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "go-icon-24 go-icon-hidden",
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn go-btn-icon",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.print.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: {
                                            placement: "topright",
                                            customClass: "go-tooltip",
                                          },
                                          expression:
                                            "{ placement: 'topright', customClass: 'go-tooltip' }",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass: "go-tooltip-area",
                                      attrs: { title: _vm.$t("report.print") },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "go-icon-24 go-icon-print",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isGuest
                          ? _c("div", { staticClass: "go-btn-group" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn go-btn-icon",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.updatingBookmark,
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.addToNewAgentBriefing.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: {
                                            placement: "topright",
                                            customClass: "go-tooltip",
                                          },
                                          expression:
                                            "{ placement: 'topright', customClass: 'go-tooltip' }",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass: "go-tooltip-area",
                                      attrs: { title: _vm.$t("report.goover") },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "go-icon-24 go-icon-goover",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.isUserNoteOrSocial
                      ? _c("note-detail", {
                          attrs: { noteData: _vm.articleDetail },
                        })
                      : _c(
                          "div",
                          {
                            ref: "contentToPrint",
                            staticClass: "go-detail-content",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "go-detail go-detail-article" },
                              [
                                _c("div", { staticClass: "go-detail-top" }, [
                                  _c("div", { staticClass: "go-elements" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn go-btn-default",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.newWidowOrigin(
                                              _vm.articleDetail.sourceUri ||
                                                _vm.getSelectedResource.url
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("em", { staticClass: "go-text" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "companyDetailCommon.referencePopoverText"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "go-elements" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-switch",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.isReadingMode,
                                              expression: "isReadingMode",
                                            },
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            type: "checkbox",
                                            id: "go-detail-mode",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.isReadingMode
                                            )
                                              ? _vm._i(
                                                  _vm.isReadingMode,
                                                  null
                                                ) > -1
                                              : _vm.isReadingMode,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = _vm.isReadingMode,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.isReadingMode =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.isReadingMode = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.isReadingMode = $$c
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "custom-control-label",
                                            attrs: { for: "go-detail-mode" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "companyDetailCommon.readingMode"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "tab-content go-tab-content" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        class: [
                                          "tab-pane fade",
                                          !_vm.isReadingMode
                                            ? "show active"
                                            : "",
                                        ],
                                        attrs: {
                                          id: "go-detail-mode-original",
                                        },
                                      },
                                      [
                                        _vm.articleDetail.s3FilePath &&
                                        (_vm.articleDetail.s3FilePath.endsWith(
                                          ".docx"
                                        ) ||
                                          _vm.articleDetail.s3FilePath.endsWith(
                                            ".doc"
                                          ) ||
                                          _vm.articleDetail.s3FilePath.endsWith(
                                            ".ppt"
                                          ) ||
                                          _vm.articleDetail.s3FilePath.endsWith(
                                            ".pptx"
                                          ) ||
                                          _vm.articleDetail.s3FilePath.endsWith(
                                            ".xlsx"
                                          ) ||
                                          _vm.articleDetail.s3FilePath.endsWith(
                                            ".xls"
                                          ) ||
                                          _vm.articleDetail.s3FilePath.endsWith(
                                            ".csv"
                                          ) ||
                                          _vm.articleDetail.s3FilePath.endsWith(
                                            ".hwp"
                                          ))
                                          ? _c(
                                              "div",
                                              {
                                                ref: "polarisArea",
                                                staticClass:
                                                  "go-report-template-01 go-detail-report",
                                                staticStyle: {
                                                  width: "100%",
                                                  height: "100%",
                                                },
                                                attrs: { id: "polaris-area" },
                                              },
                                              [
                                                _c("div", {
                                                  staticStyle: {
                                                    width: "100%",
                                                    height: "100%",
                                                    position: "absolute",
                                                  },
                                                  attrs: {
                                                    id: "weboffice_container",
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.articleDetail.s3FilePath &&
                                        _vm.articleDetail.embeddedUri &&
                                        (_vm.articleDetail.s3FilePath.endsWith(
                                          ".pdf"
                                        ) ||
                                          _vm.articleDetail.s3FilePath.endsWith(
                                            ".txt"
                                          ) ||
                                          _vm.articleDetail.s3FilePath.endsWith(
                                            ".html"
                                          ))
                                          ? _c("iframe", {
                                              attrs: {
                                                src: _vm.articleDetail
                                                  .embeddedUri,
                                              },
                                            })
                                          : _vm.articleDetail.id &&
                                            (_vm.articleDetail.id.includes(
                                              "youtube"
                                            ) ||
                                              _vm.getSelectedResource.url.includes(
                                                "youtube"
                                              ))
                                          ? [
                                              _c("iframe", {
                                                staticStyle: {
                                                  height: "800px",
                                                  width: "100%",
                                                  border: "none",
                                                  overflow: "hidden",
                                                },
                                                attrs: {
                                                  src: _vm.getLinkEmbedYoutube(
                                                    _vm.getSelectedResource
                                                      .url ||
                                                      _vm.articleDetail
                                                        .sourceUri
                                                  ),
                                                },
                                              }),
                                            ]
                                          : _c("iframe", {
                                              ref: "articleIframe",
                                              attrs: {
                                                credentialless: "",
                                                id: "article-iframe",
                                                src: _vm.articleDetail
                                                  .sourceUri,
                                                target: "_self",
                                              },
                                              on: { load: _vm.onIframeLoad },
                                            }),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        class: [
                                          "tab-pane fade",
                                          { "show active": _vm.isReadingMode },
                                        ],
                                        attrs: { id: "go-detail-mode-read" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "go-detail-inner" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "go-detail-header",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "go-detail-title",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.articleDetail
                                                          .title ||
                                                          _vm
                                                            .getSelectedResource
                                                            .title
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "go-block-bottom",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-card-info",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "go-info-item go-channel",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "go-channel-name",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .getSelectedResource
                                                                      .writer ||
                                                                      _vm
                                                                        .getSelectedResource
                                                                        .channel ||
                                                                      _vm.getHostName(
                                                                        _vm
                                                                          .articleDetail
                                                                          .sourceUri
                                                                      )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.articleDetail
                                                          .publishedAt
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "go-info-item go-datetime",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm
                                                                        .articleDetail
                                                                        .publishedAt
                                                                        ? _vm.formatDateAgo(
                                                                            _vm.moment.utc(
                                                                              _vm
                                                                                .articleDetail
                                                                                .publishedAt,
                                                                              "YYYYMMDDHHmmss"
                                                                            )
                                                                          )
                                                                        : _vm.formatDateAgo(
                                                                            _vm.moment.utc(
                                                                              _vm
                                                                                .getSelectedResource
                                                                                .publishAt,
                                                                              "YYYYMMDDHHmmss"
                                                                            )
                                                                          )
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      staticClass:
                                                        "go-elements",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "go-detail-body" },
                                              [
                                                _vm.articleDetail.serviceHtml ||
                                                _vm.articleDetail.content
                                                  ? [
                                                      _c("div", {
                                                        staticClass:
                                                          "html-content",
                                                        staticStyle: {
                                                          "word-wrap":
                                                            "break-word",
                                                        },
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.cleanHtml(
                                                              _vm.articleDetail
                                                                .serviceHtml ||
                                                                _vm
                                                                  .articleDetail
                                                                  .content
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.articleDetailListDocument.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "go-widget go-widget-sub" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "go-widget-header" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "go-widget-title" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "report.relatedDocuments"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                            _c(
                                              "small",
                                              { staticClass: "go-count" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm
                                                      .articleDetailListDocument
                                                      .length
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "go-slide-pagination",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn go-slide-nav go-slide-nav-prev",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.prevPageDocument()
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "go-icon-20 go-icon-chevron-left",
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "go-slide-page" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "go-slide-page-current",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .articleRelatedDocumentPages
                                                          .currentPage || 1
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "go-slide-page-total",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.totalPagesDocument() ||
                                                          1
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn go-slide-nav go-slide-nav-next",
                                                class:
                                                  _vm
                                                    .articleRelatedDocumentPages
                                                    .currentPage ===
                                                    _vm.totalPagesDocument() &&
                                                  "disabled",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.nextPageDocument()
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "go-icon-20 go-icon-chevron-right",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "go-widget-body",
                                        staticStyle: {
                                          "overflow-y": "scroll",
                                          height: "100px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "go-list-wrap" },
                                          [
                                            _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "go-card-sub-list go-card-related-document",
                                              },
                                              _vm._l(
                                                _vm.displayedItemsDocument(),
                                                function (item, index) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "go-list-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.handleRelatedDocument(
                                                            item._id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "go-card-sub",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "go-card-body",
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "go-card-title",
                                                                  attrs: {
                                                                    id: "go-panel-reference-detail-open",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.title
                                                                        ? _vm.subString(
                                                                            item.title
                                                                          )
                                                                        : ""
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "go-card-info",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "go-elements",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "go-channel",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              Array.isArray(
                                                                                item.writer
                                                                              )
                                                                                ? item
                                                                                    .writer[0]
                                                                                : "goover"
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "go-datetime",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.formattedDateDocument(
                                                                                item.published_at
                                                                              ) ||
                                                                                _vm.formattedDate(
                                                                                  _vm
                                                                                    .articleDetail
                                                                                    .publishedAt
                                                                                )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "go-card-img",
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  loading:
                                                                    "lazy",
                                                                  src: item.image_uri_thumbnail,
                                                                  alt: "Alternate Image",
                                                                },
                                                                on: {
                                                                  error:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      item.image_uri_thumbnail =
                                                                        "content/images/common/file/file-pdf-fill.svg"
                                                                    },
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.articleRelatedPeople.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "go-widget go-widget-sub" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "go-widget-header" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "go-widget-title" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("report.relatedPeople")
                                                ) +
                                                "\n\n                  "
                                            ),
                                            _c(
                                              "small",
                                              { staticClass: "go-count" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.articleRelatedPeople
                                                      .length
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "go-slide-pagination",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn go-slide-nav go-slide-nav-prev",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.prevPagePeople()
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "go-icon-20 go-icon-chevron-left",
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "go-slide-page" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "go-slide-page-current",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .articleRelatedPeoplePages
                                                          .currentPage
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "go-slide-page-total",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.totalPagesPeople() ||
                                                          1
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn go-slide-nav go-slide-nav-next",
                                                class:
                                                  _vm.articleRelatedPeoplePages
                                                    .currentPage ===
                                                    _vm.totalPagesPeople() &&
                                                  "disabled",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.nextPagePeople.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "go-icon-20 go-icon-chevron-right",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "go-widget-body" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "go-list-wrap" },
                                          [
                                            _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "go-card-sub-list go-card-related-people",
                                              },
                                              _vm._l(
                                                _vm.displayedItemsPeople(),
                                                function (item, index) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "go-list-item",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "go-card-sub",
                                                        },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "go-card-img",
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  loading:
                                                                    "lazy",
                                                                  src: "content/images/images_v3/sample/@sample-people-1.png",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "go-card-body",
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "go-card-title",
                                                                  attrs: {
                                                                    id: "go-panel-reference-detail-open",
                                                                    href: _vm.social(
                                                                      item
                                                                        .social
                                                                        .Facebook,
                                                                      item
                                                                        .social
                                                                        .XTwitter,
                                                                      item
                                                                        .social
                                                                        .LinkedIn,
                                                                      item
                                                                        .social
                                                                        .Instagram
                                                                    ),
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.connectomeNodeLabel
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-detail-aside" }, [
                      _c("div", { staticClass: "go-fixed-box" }, [
                        _c("div", { staticClass: "go-panel go-panel-aside" }, [
                          _c(
                            "div",
                            { staticClass: "go-panel-body" },
                            [
                              _c("ask-sub", {
                                ref: "askGoover",
                                attrs: {
                                  "reference-documents": [],
                                  page: _vm.PAGES.DISCOVERY_DETAIL,
                                  docId: _vm.getSelectedResource.docId,
                                  targetBpId: _vm.conversationId,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }